module.exports = __webpack_public_path__ + "img/119.6fda5f9a.jpg";